

//import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import navIcon4 from "../assets/img/nav-icon4.svg";
import QRCode from "qrcode.react";
import {
  Box,
  Containers,
  Rows,
  Columns,
  FooterLinks,
  Headings,
} from "./FooterStyles";
import { Link, IndexLink } from 'react-router';
import { HashLink } from 'react-router-hash-link';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';


  



export const Footer = () => {
  return (
    /*
    <footer className="footer">
      
     
     

      <div className="bls">
      
      <Container > 
      
        <Row className="align-items-center">
        
        <MailchimpForm />
        <Col size={12} sm={6}>
            <img src={navIcon4} alt="Game" />
          </Col>
          
           
          
        
        <Box>
        
         
        <Rows >

       
          <Columns className="col-md-2 col-xs-6 .col-sm-4">
            <Headings>About </Headings>
            <HashLink to='carier'>
            
            <FooterLinks href="carier">Carier</FooterLinks>
            </HashLink>
            <hr></hr>
            <HashLink to='Company'>
            <FooterLinks href="#">Company</FooterLinks>
            </HashLink>
            <hr></hr>
           <HashLink to="Contact">

            <FooterLinks href="#">Contact</FooterLinks>
          </HashLink>
            
          </Columns>
          
          
          <Columns className="col-md-2 col-xs-6 .col-sm-4">
          
            <Headings>Services</Headings>
            <HashLink to='Games'>
            
            <FooterLinks>Games</FooterLinks>
            </HashLink>
            <hr></hr>
            <HashLink to='GameDesign'>
            <FooterLinks href="#">Social</FooterLinks>
            </HashLink>
            <hr></hr>
           <HashLink to="forum">

            <FooterLinks href="">Forum</FooterLinks>
          </HashLink>
            
          </Columns>
          
          
          <Columns className="col-md-2 col-xs-6 .col-sm-4">
            
            <Headings>What's new</Headings>
            <HashLink to='carier'>
            
            <FooterLinks href="carier">Education</FooterLinks>
            </HashLink>
            <hr></hr>
            <HashLink to='ADS'>
            <FooterLinks href="#">Ads</FooterLinks>
            </HashLink>
            <hr></hr>
           <HashLink to="Contact">

            <FooterLinks href="#">Hackatons</FooterLinks>
          </HashLink>
            
          </Columns>
          
         
        </Rows>
        </Box>


       
       

        </Row>

        
        
      

      </Container>
     
      
     

            
      </div>
      <div className="bannes">
      <div className="col-12 col-md-6 col-lg-4">
      
            <p>© 2023,  Spiccato Games, All rights reserved.</p>
      </div>


      </div>
    </footer>
  
    */
    /*
    <>
    
     <div className="container">
      <Container>
              <MailchimpForm/>
            <Row md={6}>
          
            <Col>
              <img src={navIcon4} alt="Game" />
            
                
              
              
              </Col>
              
            
              <Col>
              
              <Columns className="col-md-2 col-xs-6 .col-sm-4">
            <Headings>About </Headings>
            <HashLink to='carier'>
            
            <FooterLinks href="carier">Carier</FooterLinks>
            </HashLink>
            <hr></hr>
            <HashLink to='Company'>
            <FooterLinks href="#">Company</FooterLinks>
            </HashLink>
            <hr></hr>
           <HashLink to="Contact">

            <FooterLinks href="#">Contact</FooterLinks>
          </HashLink>
            
          </Columns>
              
              </Col>
              <Col>
              <Columns className="col-md-2 col-xs-6 .col-sm-4">
          
            <Headings>Services</Headings>
            <HashLink to='Games'>
            
            <FooterLinks>Games</FooterLinks>
            </HashLink>
            <hr></hr>
            <HashLink to='GameDesign'>
            <FooterLinks href="#">Social</FooterLinks>
            </HashLink>
            <hr></hr>
           <HashLink to="forum">

            <FooterLinks href="">Forum</FooterLinks>
          </HashLink>
            
          </Columns>
          
              
             
              
              
              </Col>
              <Col>
              <Columns className="col-md-2 col-xs-6 .col-sm-4">
          
            <Headings>New</Headings>
            <HashLink to='Education'>
            
            <FooterLinks>Education</FooterLinks>
            </HashLink>
            <hr></hr>
            <HashLink to='Ads'>
            <FooterLinks href="#">Ads</FooterLinks>
            </HashLink>
            <hr></hr>
           <HashLink to="Hackathons">

            <FooterLinks href="">Hackathons</FooterLinks>
          </HashLink>
            
          </Columns>
          
              
       
          
            </Col>
            <Col size={12} sm={6} className="text-center text-sm-end">
         
           
         <div className="social-icon">
           

           <a href= "https://www.linkedin.com/in/emrekocaoglu"><img src={navIcon1} alt="Icon" /></a>
           <a href="https://www.facebook.com"><img src={navIcon2} alt="Icon" /></a>
           <a href="https://www.instagram.com"><img src={navIcon3} alt="Icon" /></a>
           <a href="https://play.google.com"><img src={navIcon4} alt="Icon" /></a>
         </div>
         
         <div className="qrcode">
             <QRCode

               value="https://www.play.google.com/"style={{ width: "28%", height: "auto",marginRight: 10,marginLeft: -900  }}/>
             <p> </p>
         </div>
         
       </Col>

          
                      <div className="col-12 col-md-6 col-lg-4">
                    <p>© 2023,  Spiccato Games, All rights reserved.</p>
              </div>
              <Col>
              </Col>
              
            </Row>
    </Container>
    
    </div>
    </>
    */
    <div className="container">
        <MailchimpForm />

        <div className="row">

            <div className="col-md-6">

                  <div className="row">

                      <div class="col-md-4 mb-md-0 mb-4">
                          
                            <Columns className="col-md-2 col-xs-6 .col-sm-4">
                              <Headings>About </Headings>
                              <HashLink to='carier'>
                              
                              <FooterLinks href="carier">Carier</FooterLinks>
                              </HashLink>
                              <hr></hr>
                              <HashLink to='Company'>
                              <FooterLinks href="#">Company</FooterLinks>
                              </HashLink>
                              <hr></hr>
                            <HashLink to="Contact">

                              <FooterLinks href="#">Contact</FooterLinks>
                            </HashLink>

                          

                            
                              
                            </Columns>
                      </div>
                      <div class="col-md-4 mb-md-0 mb-4">
                          
                            <Columns className="col-md-2 col-xs-6 .col-sm-4">
                          
                          <Headings>New</Headings>
                          <HashLink to='Education'>
                          
                          <FooterLinks>Education</FooterLinks>
                          </HashLink>
                          <hr></hr>
                          <HashLink to='Ads'>
                          <FooterLinks href="#">Ads</FooterLinks>
                          </HashLink>
                          <hr></hr>
                        <HashLink to="Hackathons">

                          <FooterLinks href="">Hackathons</FooterLinks>
                        </HashLink>

                       


                          
                        </Columns>
                      </div>

                      <div class="col-md-4 mb-md-0 mb-4">
                          
                      <Columns className="col-md-2 col-xs-6 .col-sm-4">
                    
                    <Headings>Services</Headings>
                    <HashLink to='Games'>
                    
                    <FooterLinks>Games</FooterLinks>
                    </HashLink>
                    <hr></hr>
                    <HashLink to='GameDesign'>
                    <FooterLinks href="#">Future</FooterLinks>
                    </HashLink>
                    <hr></hr>

                  
                  

                    <FooterLinks href="http://www.spiccatogames.com/forum">Forum</FooterLinks>
                
                    
                  </Columns>
                      </div>

                  
                  </div>
           </div>

        <div className="col-md-6">

          <div className="row justify-content-end">
            <div className="col-md-12 col-lg-11 mb-md-0 mb-4">
            
            
            <ul class="ftco-footer-social p-0">
            <div className="social-icon">
           

                    <a href= "https://www.linkedin.com/in/emrekocaoglu"><img src={navIcon1} alt="Icon" /></a>
                    <a href="https://www.facebook.com"><img src={navIcon2} alt="Icon" /></a>
                    <a href="https://www.instagram.com"><img src={navIcon3} alt="Icon" /></a>
                    <a href="https://play.google.com"><img src={navIcon4} alt="Icon" /></a>
                   
            </div>
         
              

              </ul>
              <img src={navIcon4} alt="Game" />
              

            </div>

            
          </div>
          
        </div>
        </div>
        <div class="row mt-5 pt-4 border-top">
            <div class="col-md-6 col-lg-8">

                  <p class="copyright">
                  © 2023,  Spiccato Games, All rights reserved.
                 
                  </p>
            <div/>
      <div/>
        </div>
  </div>
 


  </div>
 
  

   





            

  
    
  )
}







/*





*/